import { Button } from '@/components/ui/button'
import { cn } from '@/lib/cn'

export interface PaginationProps {
  /** 0-indexed current page. */
  page: number
  pageSize: number
  /** Total number of records across all pages. */
  total: number
  onPageChange: (page: number) => void
  /** Disable controls (e.g. while a fetch is in-flight). */
  disabled?: boolean
  className?: string
}

export function Pagination({
  page,
  pageSize,
  total,
  onPageChange,
  disabled,
  className,
}: PaginationProps) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize))
  const start = total === 0 ? 0 : page * pageSize + 1
  const end = Math.min(total, page * pageSize + pageSize)

  return (
    <div
      className={cn(
        'flex flex-wrap items-center justify-between gap-3 border-t p-3 text-sm',
        className,
      )}
    >
      <span className="text-muted-foreground">
        {total === 0 ? 'No records' : <>Showing {start}–{end} of {total}</>}
      </span>
      <div className="flex items-center gap-2">
        <Button
          variant="secondary"
          size="sm"
          onClick={() => onPageChange(Math.max(0, page - 1))}
          disabled={disabled || page === 0}
        >
          Previous
        </Button>
        <span className="text-muted-foreground">
          Page {page + 1} of {totalPages}
        </span>
        <Button
          variant="secondary"
          size="sm"
          onClick={() => onPageChange(page + 1)}
          disabled={disabled || page + 1 >= totalPages}
        >
          Next
        </Button>
      </div>
    </div>
  )
}
